module.exports = __webpack_public_path__ + "static/media/6COPUOS4.7c24c96d.jpg";